'use client'

import { cn } from '@/utilities/ui'
import Link from 'next/link'
import React from 'react'
import Image from 'next/image'
import { imgproxyEnabled, imgproxyLoader } from '@/utilities/imgproxy'
import { Calendar } from 'lucide-react'
import { getMediaUrl } from '@/utilities/getMediaUrl'
import { formatDateTime } from '@/utilities/formatDateTime'
import type { Post } from '@/payload-types'

export type CardPostData = Pick<
  Post,
  'slug' | 'categories' | 'meta' | 'title' | 'publishedAt' | 'heroImage'
>

export const NewsCard: React.FC<{
  className?: string
  doc?: CardPostData
  relationTo?: 'posts'
  showCategories?: boolean
  locale?: 'de' | 'en'
}> = (props) => {
  const { className, doc, relationTo } = props

  const { slug, title, publishedAt, heroImage } = doc || {}
  const basePath = relationTo === 'posts' ? 'news' : relationTo
  const href = slug ? `/${basePath}/${slug}` : `/${basePath}`
  const readMoreLabel = props.locale === 'en' ? 'Read more' : 'Weiterlesen'

  return (
    <article
      className={cn(
        'group h-full overflow-hidden bg-white shadow-md transition-shadow duration-500 hover:shadow-lg',
        className,
      )}
    >
      <Link href={href} className="block h-full">
        <div className="h-52 overflow-hidden">
          <Image
            loader={imgproxyEnabled ? imgproxyLoader : undefined}
            src={heroImage ? getMediaUrl(heroImage) : '/atonie_header.jpg'}
            alt={title || 'News image'}
            width={400}
            height={208}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-6">
          <div className="mb-3 flex items-center text-sm font-light text-gray-700">
            <Calendar className="mr-2 h-4 w-4 text-antonie-green" />
            <span>{formatDateTime(publishedAt ?? '')}</span>
          </div>
          <h3 className="mb-4 line-clamp-2 font-heading text-lg font-medium text-gray-900">
            {title}
          </h3>
          <span className="block w-full border-2 border-antonie-green px-6 py-3 text-center font-heading text-sm font-medium text-gray-900 transition-colors hover:bg-antonie-green hover:text-black">
            {readMoreLabel}
          </span>
        </div>
      </Link>
    </article>
  )
}
